import { emailIsValid, IPIValidator, isNotAnReservedEmail, ISWCValidator, valueIsEmpty } from '@App/helpers/validate'
import { isNumeric } from '@App/helpers/isNumeric'
import { IValidationSettings } from '@App/interfaces/validations'
import { DATE_REGEX } from '@Const/regexp'
import {
    EMAIL_MESSAGE,
    IS_DATE_MESSAGE,
    IS_DURATION_MESSAGE,
    IS_IPI_MESSAGE,
    IS_ISWC_MESSAGE,
    IS_LANGUAGE_MESSAGE,
    IS_NUMBER_MESSAGE,
    MAX_LENGTH_MESSAGE,
    MIN_LENGTH_MESSAGE,
    NO_RESERVED_EMAIL_MESSAGE,
    REQUIRED_MESSAGE,
    STATIC_LENGTH_MESSAGE,
} from '@Const/error-messages'

/**
 * @deprecated Use updateValidation = (object: any, validations: any): validations instead found in src/helpers/validation/form-validation.ts
 */
export const getValueForm = (
    value: string | number | boolean | null,
    id: string,
    formObject: any,
    validationObject: any
) => {
    if (typeof value === 'string') {
        formObject[id] = value.trim()
    } else {
        formObject[id] = value
    }
    const currentFieldValidation: IValidationSettings = validationObject[id]

    const requiredMessage = REQUIRED_MESSAGE
    const isNumberMessage = IS_NUMBER_MESSAGE
    const maxLengthMessage = `${MAX_LENGTH_MESSAGE} ${currentFieldValidation.maxLength}`
    const minLengthMessage = `${MIN_LENGTH_MESSAGE} ${currentFieldValidation.minLength}`
    const staticLengthMessage = `${STATIC_LENGTH_MESSAGE} ${currentFieldValidation.staticLength}`
    const emailMessage = EMAIL_MESSAGE
    const noReservedEmailMessage = NO_RESERVED_EMAIL_MESSAGE
    const isDurationMessage = IS_DURATION_MESSAGE
    const isLanguageMessage = IS_LANGUAGE_MESSAGE
    const isDateMessage = IS_DATE_MESSAGE
    const isISWC = IS_ISWC_MESSAGE
    const isIPI = IS_IPI_MESSAGE

    // MPOR-1746
    // It's too late to change every validation to pass via a function
    // specific to it, but I'm adding this here as a possible future
    // gradual change we can make to have validation logic for a
    // specific field encapsulated within its own testable function.
    // Generic validations aren't ideal for industry-specific identifiers
    // and the such.
    if (currentFieldValidation.pipeFunction) {
        if (currentFieldValidation.pipeFunction(value)) {
            switch (id) {
                case 'isrc':
                    currentFieldValidation.error =
                        'ISRC must be alpha-numeric, 12 characters long, the first two characters must be letters, and the last' +
                        ' 7 characters must be numbers'
                    break
                case 'title':
                    currentFieldValidation.error = 'Work Title is too long, and may not include multiple lines'
                    break
                default:
                    break
            }
        } else {
            currentFieldValidation.error = ''
        }
    } else {
        // We'll handle legacy logic here...
        if (typeof value === 'string' && currentFieldValidation.required && valueIsEmpty(value)) {
            currentFieldValidation.error = requiredMessage
        } else if (typeof value === 'boolean' && currentFieldValidation.required && !value) {
            currentFieldValidation.error = requiredMessage
        } else if (currentFieldValidation.isNumber && value && !isNumeric(value)) {
            currentFieldValidation.error = isNumberMessage
        } else if (
            typeof value === 'string' &&
            currentFieldValidation.maxLength &&
            value.length > currentFieldValidation.maxLength
        ) {
            currentFieldValidation.error = maxLengthMessage
        } else if (
            typeof value === 'string' &&
            currentFieldValidation.minLength &&
            value.length < currentFieldValidation.minLength
        ) {
            currentFieldValidation.error = minLengthMessage
        } else if (
            typeof value === 'string' &&
            currentFieldValidation.staticLength &&
            value &&
            value.length !== currentFieldValidation.staticLength
        ) {
            currentFieldValidation.error = staticLengthMessage
        } else if (typeof value === 'string' && currentFieldValidation.isEmail && value && !emailIsValid(value)) {
            currentFieldValidation.error = emailMessage
        } else if (
            typeof value === 'string' &&
            currentFieldValidation.noReservedEmail &&
            value &&
            !isNotAnReservedEmail(value)
        ) {
            currentFieldValidation.error = noReservedEmailMessage
        } else if (
            typeof value === 'string' &&
            currentFieldValidation.isDuration &&
            value &&
            !value.match(/^[0-9]{2}[:]{1}[0-9]{2}$/)
        ) {
            currentFieldValidation.error = isDurationMessage
        } else if (currentFieldValidation.isLanguage && currentFieldValidation.required && !value) {
            currentFieldValidation.error = isLanguageMessage
        } else if (typeof value === 'string' && currentFieldValidation.isDate && value && !isValidDate(value)) {
            currentFieldValidation.error = isDateMessage
        } else if (typeof value === 'string' && currentFieldValidation.isISWC && value && !ISWCValidator(value)) {
            currentFieldValidation.error = isISWC
        } else if (typeof value === 'string' && currentFieldValidation.isIPI && value && !IPIValidator(value, false)) {
            currentFieldValidation.error = isIPI
        } else {
            currentFieldValidation.error = ''
        }
    }

    return {
        formObject,
        validationObject,
    }
}

const isValidDate = (date: string) => date.match(DATE_REGEX)
